
 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

export  const    dashboardCard1Object = { no:1, 
    id: generateTimestamp()+3,
    cardName:"DashboardCard1",
    cardType:"editable",
    myKey:`id-Dashboard1-layout`,
   
    
          titleFonts:{ 
                headerFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } }, 
               titleFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               subtitleFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               tagsFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               buttonFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } }
               },
           



      
         topSectionCard:{ 
         bgColor:{title:"Top Bar Background Color",color:"rgba(144, 202, 249,0.1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Top Bar Layout Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
        
         middleOuterCard:{ 
         bgColor:{title:"Middle Bar Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Middle Bar Layout Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
       
         bottomOuterCard:{ 
         bgColor:{title:"Bottom Bar Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Top Bar Layout Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
        
         
        sidebarBox:{ 
         bgColor:{title:"Button Outer Box Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Button Outer Box  Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
 sidebarHeader:{ 
         bgColor:{title:"Button Outer Box Background Color",color:"rgba(246, 251, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        textColor:{title:" Quiz Title Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Button Outer Box  Radius",
         topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}}},













        
         profileImageThumbnail: {  
        
         status: true,
                  type:"s3Key", //link , s3Key
                  src:"https://i.postimg.cc/YqL98KD8/classmock-Logo-With-Name.png",
                  s3Key:"",
         aspectRatio:{title:"Logo Image Crop Ratio",value:"1/1"},
          
         borderRadius:{title:"Logo Image Radius",
         topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
         topRight:{title:"Top Right Radius",value:50,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
         border:{title:" Logo Image  Border",borderType:"solid",
         borderWidth:{title:"Border Width",value:4,resolution:"px"}
        ,borderColor:{title:"Logo Border Color",color:"rgba(144, 202, 249,0.5)",colors:{},alpha:1}},
         }, 
                
         
         sidebarNavBtn:{  
          textColor:{title:"Que Paper Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Que Paper Btn  BG Color",color:"rgba(144, 202, 249,1)",colors:{color1:"rgba(144, 202, 249,0.1)",color3:"rgba(144, 202, 249,0.3)",color6:"rgba(144, 202, 249,0.6)"},alpha:1},
          iconColor:{title:"Que Paper Btn  icon Color",color:"rgba(51, 51, 51, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Que Paper Btn Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Que Paper Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
                  dashboardOuter:{ 
         bgColor:{title:"Button Outer Box Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        textColor:{title:" Quiz Title Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Button Outer Box  Radius",
         topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}}},


                 statsOuter:{ 
         bgColor:{title:"Button Outer Box Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        textColor:{title:" Quiz Title Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Button Outer Box  Radius",
         topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}}},


         statBtn:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(239, 248, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
         statInfoBtn:{  
          bgColor:{title:" Fullscreen Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Fullscreen  Btn  icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(136, 136, 136, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Fullscreen  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                }, statCircleCard:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(239, 248, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
          coursesOuter:{ 
         bgColor:{title:"Button Outer Box Background Color",color:"rgba(252, 254, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        textColor:{title:" Quiz Title Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        border:{title:"Card  Border",borderType:"solid",borderWidth:{title:"Border Width",value:3,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(212, 232, 249, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Button Outer Box  Radius",
         topLeft:{title:"Top Left Radius",value:15,resolution:"px"},
         topRight:{title:"Top Right Radius",value:15,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:15,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:15,resolution:"px"}}},
  filterCardOuter:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(243, 250, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                }
                ,filterPaidTab:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(169, 229, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(200, 231, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },filterLifetimeTab:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(255, 196, 196, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(200, 231, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },filterAdvancedTab:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(173, 221, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(151, 209, 253, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },filterDropdownTab:{  
            bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         
                },
                filterCalendarBtn:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:3,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },filterCalendarDateTab:{  
            bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(144, 202, 249,0.4)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
            textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
       
                },
                 filterSortBtn:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:3,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
          topRight:{title:"Top Right Radius",value:50,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
       
                },
                courseImageThumbnail: {  
        
         status: true,
                  type:"s3Key", //link , s3Key
                  src:"https://i.postimg.cc/t4YRDRbd/6390.jpg",
                  s3Key:"",
         aspectRatio:{title:"Logo Image Crop Ratio",value:"3/2"},
          
         borderRadius:{title:"Logo Image Radius",
         topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
         topRight:{title:"Top Right Radius",value:5,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
         border:{title:" Logo Image  Border",borderType:"solid",
         borderWidth:{title:"Border Width",value:0,resolution:"px"}
        ,borderColor:{title:"Logo Border Color",color:"rgba(144, 202, 249,0.5)",colors:{},alpha:1}},
         }, 
             
    courseBtn1Card:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(200, 231, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(200, 231, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },

  courseBtn2Card:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(200, 231, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(200, 231, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },

  courseTopMenuBtnCard:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },
  courseInfoTab:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(249, 249, 249, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },
  courseTabBtn1Card:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },
 courseTabBtn2Card:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                }, courseTabBtn3Card:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                }, courseTabBtn4Card:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },
  courseContinueLearnBtn:{  
          textColor:{title:"Instruction Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Instruction  Btn  BG Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Instruction  Btn  icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Instruction  Btn Icon BG Color",color:"rgba(200, 231, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(250, 250, 250, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },







       pauseBtn:{  
          bgColor:{title:" Pause Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Pause  Btn  icon Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Pause  Btn Radius",
          topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
          topRight:{title:"Top Right Radius",value:50,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
       
                },
       
         quizTimer:{ 
            theme:"T2", // T1 ,T2 
           textColor:{title:"Quiz Timer Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        
          bgColor:{title:" Quiz Timer  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,0.51)",colors:{},alpha:1}},
          borderRadius:{title:"quizTimer  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
















     notVisitedBtn:{  
          btnTheme:"T1",
          textColor:{title:"Not Visited Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Not Visited Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(125, 181, 220, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },
  answeredBtn:{  
          btnTheme:"T1",
          textColor:{title:"Not Visited Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Not Visited Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(125, 181, 220, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}},
       
                },

  notAnsweredBtn:{  
          btnTheme:"T1",
          textColor:{title:"Not Visited Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Not Visited Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(125, 181, 220, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Instruction  Btn Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },
  markedBtn:{  
          btnTheme:"T1",
          textColor:{title:"Marked  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Marked  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Marked  Btn  Dot Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Marked   Btn Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
       
                },
  






 PaletteTimer:{  
         title:"Time Spent",
          textColor:{title:"Palette Timer Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Palette Timer Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Palette Timer Btn Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
       
                },









 sectionAll:{  title:"All Sections",
           textColor:{title:"Section All Btn  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Section All  Btn  BG Color",color:"rgba(144, 202, 249,0.3)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Section All Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
 sectionAllInner:{  title:"All Sections Inner",
          textColor:{title:"Section All Inner Btn  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Section All Inner Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Section All Inner Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },







 bookmarkBtn:{  
         
           bgColor:{title:"Bookmark Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Bookmark Btn  Dot Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Bookmark Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
    flagBtn:{  
         
           bgColor:{title:"Flag Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Flag Btn  Dot Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Flag Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
         calculatorBtn:{  
         
           bgColor:{title:"Calculator Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Calculator Btn  Dot Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Calculator Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
    



















questionTimer:{
 textColor:{title:"Question Timer Btn  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Question Timer  Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Question Timer Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,0.51)",colors:{},alpha:1}},
          borderRadius:{title:"Question Timer Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
},
    
plusMarks:{
 textColor:{title:"Que Marks Btn  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Que Marks Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Que Marks  Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,0.51)",colors:{},alpha:1}},
          borderRadius:{title:"Que Marks Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}}} ,

negativeMarks:{
 textColor:{title:"Negative Marks Btn  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Negative Marks Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Negative Marks  Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,0.51)",colors:{},alpha:1}},
          borderRadius:{title:"Negative Marks Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
},


 questionBoxCard:{ 
         bgColor:{title:"Question Box Background Color",color:"rgba(144, 202, 249,0.1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
         borderRadius:{title:"Question Box Radius",
         topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}}},


queType:{
 textColor:{title:"Que Type Btn  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Que Type Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Que Type Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,0.51)",colors:{},alpha:1}},
          borderRadius:{title:"Que Type Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
},

difficultyLevel:{
 textColor:{title:"Difficulty Level Btn  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Difficulty Level Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Difficulty Level Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,0.51)",colors:{},alpha:1}},
          borderRadius:{title:"Difficulty Level Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
},

questionName:{
 textColor:{title:"Question Name Btn  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           iconColor:{title:"Question Name  Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Question Name  Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
},

        
         optionBoxCard:{ 
         bgColor:{title:"Option Box Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Option Box Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},




























           
         profileBox:{ 
         bgColor:{title:"Profile Box Background Color",color:"rgba(144, 202, 249,0.1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Profile Box  Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
    
         profileName:{ 
              textColor:{title:"Profile Name Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        
         bgColor:{title:"Profile Name Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Profile Name  Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
      
         profileImage: {  
         bgColor:{title:"Profile Image BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
        
         status: true,
                  type:"s3Key", //link , s3Key
                  src:"https://i.postimg.cc/G24xxVq7/smiling-pensive-brunette-schoolgirl-with-long-hair-hugging-book.jpg",
                  s3Key:"",
         aspectRatio:{title:"Profile Image Crop Ratio",value:"1/1"},
          
         borderRadius:{title:"Profile Image Radius",
         topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
         topRight:{title:"Top Right Radius",value:50,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
         border:{title:" Profile Image  Border",borderType:"solid",
         borderWidth:{title:"Border Width",value:4,resolution:"px"}
        ,borderColor:{title:"Profile Border Color",color:"rgba(144, 202, 249,0.51)",colors:{},alpha:1}},
         },
  

         PaletteBox:{ 
         bgColor:{title:"Palette Box Background Color",color:"rgba(144, 202, 249,0.21)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Palette Box  Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
      
         gridListBtnBox:{ 
         bgColor:{title:"Grid List Btn Box Background Color",color:"rgba(144, 202, 249,0.21)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Grid List Btn Box  Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
      

          gridListBtn:{  
          textColor:{title:"Grid List Btn Text Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Grid List  Btn  BG Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Grid List Btn  icon Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Grid List Btn Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Grid List Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },



          gridListActiveBtn:{  
          textColor:{title:"Grid List Active Btn Text Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Grid List Active Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Grid List Active Btn  icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Grid List Active Btn Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Grid List Active Btn Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
       
                },


                

         buttonBox:{ 
         bgColor:{title:"Button Box Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Button Box  Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
    
         buttonInfoInner:{  
           textColor:{title:"Button  Info Inner Btn  Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Button  Info  Inner Btn  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Button  Info  Inner Btn Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
       
                },

          markBtn:{  
          textColor:{title:"Mark Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Mark Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
            border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Mark Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
  clearBtn:{  
          textColor:{title:"Clear Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Clear Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
            border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Clear Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
 previousBtn:{  
          textColor:{title:"Previous Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Previous Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Previous Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
saveAndNextBtn:{  
          textColor:{title:"Save And Next Btn Text Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Save And Next Btn  BG Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Save And Next Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },

submitTestBtn:{  
          textColor:{title:"Submit Test Btn Text Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Submit Test Btn  BG Color",color:"rgba(88, 162, 223, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(88, 162, 223, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Submit Test Btn Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },


  hintBtn:{  
          textColor:{title:"Hint  Btn Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Hint Btn  BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Hint  Btn  icon Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Hint  Btn Radius",
          topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
          topRight:{title:"Top Right Radius",value:50,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
       
                },





// Options Styles    

optionTrueFalse:{},

optionNAT:{},

optionMCQ:{},

optionMSQ:{},

optionEssay:{},

optionFillBlanks:{},

optionDragMatching:{},

optionDragReOrdering:{},

optionVideoListening:{},

optionAudioListening:{},

optionReading:{},

optionSpeaking:{},








playPausePopUp:{},

reportQuestionPopUp:{},

hintPopUp:{},

startTestBoxPopUp:{}, 

submitTestInfoPopUp:{},

instructionsPopUp:{},
      




        }